import script from "./BookingWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./BookingWrapper.vue?vue&type=style&index=0&id=60c76bcb&scoped=true&lang=scss"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60c76bcb"]])

export default __exports__